<template>
  <div class="auth-page">
    <div class="auth-container">
      <div class="auth-logo">
        <img src="../assets/img/assuraf_lg.png" alt="Assuraf Logo" />
      </div>

      <div class="auth-card ml-4 mr-4">
        <div class="auth-card-header">
          <div class="title-row">
            <div class="icon-badge"><i class="fa fa-key"></i></div>
            <h2 class="form-title">{{ $t('account_activation.title') }}</h2>
          </div>
        </div>

        <p class="auth-description">{{ $t('account_activation.description') }}</p>

        <div v-if="isInitial || isLoading" class="text-center mr-4">
          <v-btn depressed class="auth-button" @click="activateAccount" :disabled="isLoading">
            <span v-if="isLoading" class="loading-span">
              <v-progress-circular
                indeterminate
                color="black"
                size="20"
                width="2"
                class="mr-2"
              ></v-progress-circular>
              <span class="text-black">{{
                $t('account_activation.button_activation_loading_text')
              }}</span>
            </span>
            <span v-else>{{ $t('account_activation.button_activate_label') }}</span>
          </v-btn>
        </div>

        <div v-else-if="isSuccess" class="text-center">
          <v-icon large color="green" class="mb-3">mdi-check-circle-outline</v-icon>
          <p class="success-message">{{ message }}</p>
          <p v-if="userData.email" class="user-email">Email : {{ userData.email }}</p>
          <v-btn depressed class="auth-button mt-4" @click="goToLogin">{{
            $t('account_activation.button_connecter_label')
          }}</v-btn>
        </div>

        <div v-else-if="isError" class="text-center">
          <v-icon large color="red" class="mb-3">mdi-alert-circle-outline</v-icon>
          <p class="error-message">{{ message }}</p>
          <div class="actions justify-content-center row">
            <v-btn depressed class="auth-button" @click="retryActivation()">
              {{ $t('account_activation.button_activate_label') }}
            </v-btn>

            <!--            <a @click="goToLogin" class="back-link">Retour à la connexion</a>-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Api from '../services/Api';

export default {
  name: 'ActivationPage',
  data() {
    return {
      isInitial: true,
      isLoading: false,
      isSuccess: false,
      isError: false,
      message: '',
      userData: {},
      token: null
    };
  },
  created() {
    this.token = this.$route.query.token;
    if (!this.token) {
      this.isInitial = false;
      this.isLoading = false;
      this.isError = true;
      this.message = "Le lien d'activation est invalide ou a expiré. Aucun token trouvé.";
    }
  },
  methods: {
    async activateAccount() {
      this.isInitial = false;
      this.isLoading = true;
      this.isError = false;
      this.isSuccess = false;

      try {
        const response = await Api().get(`/user/activation/${this.token}`);
        if (response.status === 200 && response.data.data.account_status === 'enabled') {
          this.isSuccess = true;
          this.message = response.data.msg || 'Compte activé avec succès !';
          this.userData = response.data.data;
        } else {
          throw new Error(response.data.msg || 'La réponse du serveur est inattendue.');
        }
      } catch (error) {
        this.isError = true;
        this.message =
          (error.response && error.response.data && error.response.data.msg) ||
          "Une erreur est survenue lors de l'activation. Veuillez réessayer.";
      } finally {
        this.isLoading = false;
      }
    },
    retryActivation() {
      if (this.token) {
        this.activateAccount();
      }
    },
    goToLogin() {
      this.$router.push('/'); // Assurez-vous que 'Login' est le nom de votre route de connexion
    }
  }
};
</script>

<style scoped>
.auth-page {
  background-color: #f7f8fa;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.auth-container {
  width: 100%;
  max-width: 580px;
}

.auth-logo {
  text-align: center;
}

.auth-logo img {
  max-width: 150px;
}

.auth-card {
  background-color: #ffffff;
  border-radius: 8px;
  padding: 2rem;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
}

.auth-card-header {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1.5rem;
}

.auth-icon-wrapper {
  background-color: #fff0de;
  border-radius: 8px;
  padding: 0.5rem;
  margin-right: 1rem;
  display: inline-flex;
}

.auth-icon-wrapper img {
  width: 24px;
  height: 24px;
}

.auth-title {
  font-size: 1.5rem;
  font-weight: 600;
  color: #333;
}

.auth-description {
  text-align: center;
  color: #6c757d;
  padding: 0 1rem;
  font-weight: 400;
}

.message-text {
  font-size: 1rem;
  color: #555;
}

.success-message {
  font-size: 1.2rem;
  color: #4caf50;
  font-weight: 500;
}

.error-message {
  font-size: 1.3rem;
  color: #f44336;
  font-weight: 500;
}

.user-email {
  color: #555;
  margin-top: 0.5rem;
}

.auth-button {
  background-color: #ffa409 !important;
  color: white !important;
  font-weight: bold;
  text-transform: none;
  border-radius: 8px;
  padding: 12px 24px;
  width: 100%;
}

.auth-actions {
  margin-top: 1.5rem;
  display: flex;
  justify-content: center;
  gap: 1.5rem;
}

.retry-link,
.back-link {
  color: #ffa409;
  font-weight: 500;
  cursor: pointer;
  text-decoration: none;
}

.retry-link:hover,
.back-link:hover {
  text-decoration: underline;
}

.loading-span {
  display: flex;
  align-items: center;
  justify-content: center;
}

.title-row {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 8px;
}
.title-row .icon-badge {
  margin-bottom: 0;
}
.title-row .form-title {
  margin: 0;
}

.form-title {
  font-size: 24px;
  font-weight: 700;
  margin: 8px 0 4px;
}
.actions {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-top: 16px;
}
.btn-primary {
  height: 44px;
  padding: 0 22px;
  border-radius: 8px;
  background: #ffa409;
  color: #fff;
  border: none;
  cursor: pointer;
  font-weight: 400;
}
.btn-primary:disabled {
  background: #ffa409;
  cursor: not-allowed;
  //opacity: 0.7;
}
.btn-primary:hover {
  filter: brightness(1.05);
}

.icon-badge {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(145deg, #ffa409, #ffa400);
  box-shadow: 0 12px 28px rgba(234, 177, 54, 0.35);
  color: #000;
  margin-bottom: 16px;
}
.icon-badge i {
  font-size: 18px;
}
</style>